import React from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';

import { InfoBadge } from '@tmapy/style-guide';

import { actionLoadData, actionSetEndpointQuery } from '../actions';
import { ENDPOINT_CATALOG_DATA } from '../constants';

type TagProps = {
  label: string;
};

export const Tag: React.FC<TagProps> = ({ label }) => {
  const dispatch = useDispatch();

  const onClick = () => {
    dispatch(actionSetEndpointQuery({ endpoint: ENDPOINT_CATALOG_DATA, query: { fts: label } }));
    dispatch(actionLoadData({ endpoint: ENDPOINT_CATALOG_DATA }));
  };

  return (
    <Link to={'/'} onClick={onClick}>
      <InfoBadge>{label}</InfoBadge>
    </Link>
  );
};
